import ConnectEventTracking from './ConnectEventTracking';
import EventTrackingProvider from './EventTrackingProvider';
import withEventTracking from './withEventTracking';
import { initGA, sendGAEvent, setGADimension } from './GoogleAnalytics';
import { initFBPixel, sendFBEvent } from './Facebook';

var sendEvent = function sendEvent(_ref) {
  var category = _ref.category,
      action = _ref.action,
      label = _ref.label,
      value = _ref.value,
      _ref$options = _ref.options,
      options = _ref$options === undefined ? {} : _ref$options;

  sendGAEvent({ category: category, action: action, value: value, label: label, options: options });
};

var setDimension = function setDimension(dimension, value) {
  setGADimension(dimension, value);
};

export { ConnectEventTracking, EventTrackingProvider, withEventTracking, initGA, initFBPixel, sendFBEvent, sendEvent, setDimension };


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/util-user-tracking/es/index.js
// module id = 628
// module chunks = 1